export const createSearchQueryController = ({
  clearSearchPin,
  handleCampusChange,
  handleSelect,
  getIsReady,
  getSvgRoot,
  getSearchArrayLength,
  getCurrentCampus,
}) => {
  let processedSearchSignature = null;
  let pendingSearchSelection = null;

  const serializeSignature = ({ target, campus }) =>
    JSON.stringify({
      target: target ?? null,
      campus: campus ?? null,
    });

  // 検索に応じて、URL上の検索クエリパラメータを更新する
  const updateSearchParamsFromSelection = ({ target_id, campus }) => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);

    if (target_id) params.set("target", target_id);
    else params.delete("target");

    if (campus) params.set("campus", campus);
    else params.delete("campus");

    const newQuery = params.toString();
    const newUrl =
      window.location.pathname +
      (newQuery ? `?${newQuery}` : "") +
      window.location.hash;

    window.history.replaceState({}, "", newUrl);
    processedSearchSignature = null;
  };

  // 安全にPinを表示
  const tryHandlePendingSearchSelection = () => {
    if (
      pendingSearchSelection &&
      getIsReady() &&
      getSvgRoot() &&
      getSearchArrayLength() > 0
    ) {
      const { target_id, campus: targetCampus } = pendingSearchSelection;

      // キャンパスが異なる場合はキャンパス変更を優先
      if (targetCampus !== getCurrentCampus()) {
        handleCampusChange(targetCampus);
        return;
      }

      handleSelect(target_id);
      pendingSearchSelection = null;
    }
  };

  // 検索クエリパラメータから検索をキューに入れる
  const queueSearchFromQuery = () => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const target = params.get("target");
    const campusParam = params.get("campus");
    const campus = campusParam ? Number(campusParam) : null;

    const currentSignature = serializeSignature({
      target,
      campus,
    });
    if (currentSignature === processedSearchSignature) return;
    processedSearchSignature = currentSignature;

    if (!target) {
      pendingSearchSelection = null;
      clearSearchPin();
      return;
    }

    pendingSearchSelection = {
      target_id: target,
      campus,
    };
  };

  // 検索選択を処理する
  const handleSearchSelection = (value, reason) => {
    if (reason === "select-option" && value) {
      if (value.target_id) {
        updateSearchParamsFromSelection({
          target_id: value.target_id,
          campus: value.campus,
        });
        queueSearchFromQuery();
        tryHandlePendingSearchSelection();
      }
      if (typeof document !== "undefined") {
        document.activeElement?.blur?.();
      }
      return;
    }

    if (reason === "clear" || (reason === "input" && !value)) {
      updateSearchParamsFromSelection({
        target_id: null,
        campus: null,
      });
      pendingSearchSelection = null;
      clearSearchPin();
    }
  };

  return {
    queueSearchFromQuery,
    updateSearchParamsFromSelection,
    tryHandlePendingSearchSelection,
    handleSearchSelection,
  };
};
